const RefundPolicy = () => {
  return (
    <div data-testid="refund-policy-page" className="pt-32 pb-20 bg-white">
      <div className="container-main">
        <div className="max-w-3xl mx-auto">
          <h1 className="font-heading text-4xl text-[#2D2D2D] mb-8">Refund & Cancellation Policy</h1>
          <p className="text-[#6E6E6E] mb-8">Last updated: December 2024</p>

          <div className="prose prose-gray max-w-none">
            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">1. Consultation Cancellations</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Initial consultations are complimentary and can be rescheduled or cancelled at 
                any time without penalty. We appreciate at least 24 hours notice for any 
                cancellations to allow us to accommodate other clients.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">2. Project Cancellation by Client</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                If you wish to cancel a project after signing the agreement:
              </p>
              <ul className="list-disc list-inside text-[#6E6E6E] space-y-2 mb-4">
                <li><strong>Before work begins:</strong> Full refund of deposit minus a 10% administrative fee</li>
                <li><strong>After work has started:</strong> Refund will be calculated based on work completed and materials ordered</li>
                <li><strong>Custom materials:</strong> Non-refundable once ordered, as these cannot be returned</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">3. Project Cancellation by Decors Genius</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                In rare circumstances where we must cancel a project (due to unforeseen 
                circumstances, safety concerns, or inability to meet client requirements), 
                we will provide a full refund of any unused deposits and assist in finding 
                alternative service providers.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">4. Satisfaction Guarantee</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                We are committed to your satisfaction. If you are not happy with our work, 
                please notify us within 7 days of project completion. We will work with you 
                to address any concerns and make reasonable adjustments at no additional cost.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">5. Refund Process</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">
                Approved refunds will be processed within 10-14 business days using the 
                original payment method. You will receive email confirmation once the 
                refund has been initiated.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">6. Non-Refundable Items</h2>
              <p className="text-[#6E6E6E] leading-relaxed mb-4">The following are non-refundable:</p>
              <ul className="list-disc list-inside text-[#6E6E6E] space-y-2 mb-4">
                <li>Custom-ordered materials and furnishings</li>
                <li>Design fees for completed design proposals</li>
                <li>Services that have been fully rendered</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-4">7. Contact Us</h2>
              <p className="text-[#6E6E6E] leading-relaxed">
                To request a cancellation or discuss a refund, please contact us at:<br />
                Email: support@decorsgenius.store<br />
                Phone: +1-888-880-1455
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicy;
